const evento = {
  nome: 'Semana Acadêmica da Computação',
  edicao: 'XVI',
  inicio: '2021-10-25',
  fim: '2021-10-28',
};

export default evento;
